import React, { useState, useEffect } from 'react';
import moment from 'moment';
import Search from '../Search/index';
import Navigation from '../Navigation/index';

import { Header, FlexHead, DateSpan, Title } from './style';

const SiteHeader = ( ) => {
    const [date, setDate] = useState('');

    useEffect(() => {
        setDate(moment().format('MMM Do, YYYY'));
    }, []);

    return (
        <Header>
            <Title>Bull & Bear</Title>
            <FlexHead >
                <DateSpan>{date}</DateSpan>
                <Search />
            </ FlexHead>
            <Navigation />
        </Header>
    );
};

export default SiteHeader;